import type { FC } from 'react';
import { Trans } from 'react-i18next';

import { Anchor, Body2 } from '@myphx-engineering/phx-design-system';

import type { PathwayTerms } from '../../../../configuration/shared';
import type { FillPathway } from '../../../../contexts/fill';
import type {
    AuthorizedMedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../../../graphql/generated/graphql';
import { useDrugKey } from '../../../../hooks/use-drug-key';
import { getAbsoluteRoute } from '../../../../util/get-absolute-route';

export type PricingTermsLinkProps = {
    medication:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment;
    pathway: FillPathway;
    terms: PathwayTerms | null;
};

export const PricingTermsLink: FC<PricingTermsLinkProps> = ({
    medication,
    pathway,
    terms,
}) => {
    const drugKey = useDrugKey(medication);

    if (!drugKey || !terms) {
        return null;
    }

    return (
        <Body2>
            <Trans
                i18nKey="fill.pricing.seeTerms"
                components={{
                    1: (
                        <Anchor
                            href={getAbsoluteRoute(
                                'programs.drugKey.terms.pathway',
                                { drugKey, pathway }
                            )}
                        />
                    ),
                }}
            />
        </Body2>
    );
};
